import React from 'react';
import { SvgIcon } from '@mui/material';

function WarningIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="10.23 7.16 55.53 51.34">
      <path
        d="M42.2623 11.5408L63.2706 49.3838C65.0744 52.6331 62.7248 56.625 59.0084 56.625H16.9916C13.2752 56.625 10.9255 52.6331 12.7294 49.3838L33.7377 11.5408C35.5948 8.19569 40.4052 8.19569 42.2623 11.5408Z"
        stroke="#EFEFEF"
        strokeWidth="3.75"
        strokeLinejoin="round"
        fill="none"
      ></path>
      <path
        d="M39.7812 22.2273L39.5149 41.8295H36.4254L36.1591 22.2273H39.7812ZM37.9702 49.7131C37.3132 49.7131 36.7495 49.4778 36.2789 49.0073C35.8084 48.5368 35.5732 47.973 35.5732 47.3161C35.5732 46.6591 35.8084 46.0953 36.2789 45.6248C36.7495 45.1543 37.3132 44.919 37.9702 44.919C38.6271 44.919 39.1909 45.1543 39.6614 45.6248C40.1319 46.0953 40.3672 46.6591 40.3672 47.3161C40.3672 47.7511 40.2562 48.1506 40.0343 48.5146C39.8212 48.8786 39.5327 49.1715 39.1687 49.3935C38.8136 49.6065 38.4141 49.7131 37.9702 49.7131Z"
        fill="#EFEFEF"
      ></path>
    </SvgIcon>
  );
}

export default WarningIcon;
